import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Slider from "react-slick";
import { BaseUrl } from '../../helper/BaseUrl';

export default function ProjectBanner({ initialData }) {
    const { slug } = useParams();
    const [data, setData] = React.useState(initialData || {});
    const navigate = useNavigate();
    const aifetcher = async () => {
        try {
            const response = await fetch(`${BaseUrl}/api/project/view/${slug}`, {
                method: 'GET',
            });
            if (!response.ok) {
                navigate("/404", { replace: true });
                return;
            }
            const result = await response.json();
            if (!result?.project) {
                navigate("/404", { replace: true });
                return;
            }
            setData(result.project);
        } catch (error) {
            console.error('Fetch error:', error.message);
            navigate("/404", { replace: true });
        }
    };

    React.useEffect(() => {
        aifetcher();
    }, [slug]);

    const settingskey = {
        autoplay: true,
        speed: 4000,
        infinite: true,
        arrows: false,
        dots: true,
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };
    return (
        <>
            <section className="project-banner-sec"
                style={{
                    backgroundImage: data?.background_image
                        ? `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${BaseUrl}${data.background_image})`
                        : "none",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }} >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="project-breadcumb">
                                <div className="breadcumb-area">
                                    <ul>
                                        <li><Link to={"/"}>Home</Link> </li>
                                        <li>/</li>
                                        <li><Link to={"/project"}>Projects</Link> </li>
                                        <li>/</li>
                                        <li><span>{data?.title ? data.title.slice(0, 20) + "..." : ""}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-md-12 col-lg-6">
                            <Slider {...settingskey} className="project-sliders">
                                {data?.images?.length > 0 &&
                                    data.images.map((img, index) => (
                                        <div className="project-banner-col" key={index}>
                                            <div className="project-banner-image">
                                                <img src={img?.image ? `${BaseUrl}${img.image}` : undefined} className="img-responsive" alt={img?.alt_image} loading="lazy" />
                                            </div>
                                        </div>
                                    ))}
                            </Slider>
                        </div>

                        <div className="col-md-12 col-lg-6">
                            <div className="project-banner-content">
                                <span className="united-state"><img src="/assets/images/location-image.webp" alt="Location" className="img-responsive" />{data?.continent}</span>
                                <h1 className="heading">{data?.country}</h1>
                                <div className="project-des"> {data?.title}</div>
                                <p className="field-wrapper">Field: {data?.project_type}</p>
                                <div dangerouslySetInnerHTML={{ __html: data?.description }} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}
